/* eslint-disable react/jsx-no-target-blank */
import Logo from "../../Assets/Logo/Logo White.svg";
import "./Footer.css";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple, faFacebook, faGoogle, faGooglePlay, faInstagram, faLinkedin, faMedium, faMicrosoft, faTiktok, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { use } from "react";

function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-black text-gray-400 px-6 md:px-16 lg:px-24 py-12">
      <div className="flex flex-col lg:flex-row justify-between gap-12 max-w-7xl mx-auto">

        {/* Brief Introduction */}
        <div className="lg:w-1/3">
          <p className="text-xl font-semibold text-white mb-4 text-center">Brief Introduction</p>
          <p className="text-center">
            IzzyAI is an AI-powered speech language therapy app that provides personalized assessments and treatment plans
            for all five major speech disorders. Designed for convenience and effectiveness, it empowers users to take
            control of their speech therapy journey—anytime, anywhere.
          </p>
        </div>

        {/* Useful Links */}
        <div className="lg:w-1/3">
          <p className="text-xl font-semibold text-white mb-4 text-center">Useful Links</p>
          <div className="flex flex-col gap-2 text-center">
            <a href="/" className="hover:underline">Home</a>
            <a href="/" className="hover:underline">How IzzyAI Can Help?</a>
            <a href="/" className="hover:underline">Company</a>
            <a href="/pricing" className="hover:underline">Plans & Pricing</a>
            <a href="/" className="hover:underline">Request A Demo</a>
            <a href="/" className="hover:underline">Signup For Waitlist</a>
            <a href="/" className="hover:underline">Contact Us</a>
            <a href="/" className="hover:underline">Download</a>
          </div>
        </div>

        {/* Contact Us */}
        <div className="lg:w-1/3">
          <p className="text-xl font-semibold text-white mb-4 text-center">Contact Us</p>
          <p className="text-center"><a className="hover:underline" href="tel:+18444999244">1844-IZZYAI-9244</a></p>
          <p className="text-center"><a className="hover:underline" href="mailto:hello@izzyai.com">hello@izzyai.com</a></p>
          <p className=" text-center bg-clip-text text-transparent bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] cursor-pointer"
            onClick={() => window.open("https://www.izzyai.com", "_blank")}>
            www.IzzyAI.com
          </p>
          <div className="flex gap-4 mt-4 justify-center">
            <FontAwesomeIcon icon={faApple} />
            <FontAwesomeIcon icon={faGoogle} />
            <FontAwesomeIcon icon={faGooglePlay} />
            <FontAwesomeIcon icon={faMicrosoft} />
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="h-px bg-[#262626] my-10 max-w-7xl mx-auto" />

      {/* Bottom Bar */}
      <div className="flex flex-col sm:flex-row justify-between items-center text-sm px-4 md:px-0 max-w-7xl mx-auto gap-5">
        <p className="text-center sm:text-left">
          Copyright ©2024 Victoriam Inc. - All rights reserved.
        </p>
        <div className="flex gap-5">
          <a href="https://www.facebook.com/IzzyAI4SLP" className="text-[#2DEEAA]" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href="https://www.instagram.com/speechguardian" className="text-[#2DEEAA]" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="https://x.com/IzzyAI4SLP" className="text-[#2DEEAA]" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://www.tiktok.com/@speechguardian28?_t=ZN-8wl9H8psPEE&_r=1" className="text-[#2DEEAA]" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faTiktok} />
          </a>
          <a href="/" className="text-[#2DEEAA]" target="_blank">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href="/" className="text-[#2DEEAA]" target="_blank">
            <FontAwesomeIcon icon={faMedium} />
          </a>
        </div>
      </div>
    </footer>

  );
}

export default Footer;
